import React from "react";
var __jsx = React.createElement;
import isString from 'lodash/isString';
import { useFormContext } from 'react-hook-form';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import DateInput from 'components/common/DateInput';
import { validateAgainstPublishDateOptions } from 'libs/content/utils';
import { getPageMetaData } from 'redux/content';

var DateField = function DateField(_ref) {
  var formField = _ref.formField;
  var intl = useIntl();

  var _useSelector = useSelector(getPageMetaData),
      pageMetaData = _useSelector.value;

  var _useFormContext = useFormContext(),
      getValues = _useFormContext.getValues;

  var current = getValues(formField.name);
  var currentValue = isString(current) ? current : '';
  return __jsx(DateInput, {
    name: formField.name,
    label: intl.formatMessage({
      id: formField.labelId
    }),
    defaultValue: formField.defaultValue !== null ? new Date(formField.defaultValue) : undefined,
    options: formField.validateAgainstPublishedAt === true ? validateAgainstPublishDateOptions(pageMetaData, currentValue) : {},
    withTime: formField.withTime
  });
};

export default DateField;